"use client";
import { j as h } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as s from "react";
import { Children as F, isValidElement as I } from "react";
import { t as O } from "./tv.config-BuYIgndg.mjs";
import { u as U } from "./useControlled-B2rPEZCb.mjs";
import { u as _ } from "./useEventCallback-CjuAhyNz.mjs";
import { u as D } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { w as H } from "./warn-BEDWsnVv.mjs";
import { C as L } from "./CompositeList-BwSEPM9t.mjs";
import { u as S } from "./DirectionContext-D4ZBZehF.mjs";
import { A as q } from "./AccordionRootContext-BOaLElCp.mjs";
import { u as T } from "./useRenderElement-B8V3_e8R.mjs";
const z = {
  value: () => null
}, y = /* @__PURE__ */ s.forwardRef(function(r, a) {
  const {
    render: x,
    className: R,
    disabled: t = !1,
    hiddenUntilFound: n,
    keepMounted: i,
    loop: A = !0,
    onValueChange: E,
    openMultiple: C = !0,
    orientation: l = "vertical",
    value: p,
    defaultValue: V,
    ...N
  } = r, f = S();
  process.env.NODE_ENV !== "production" && D(() => {
    n && i === !1 && H("The `keepMounted={false}` prop on a Accordion.Root will be ignored when using `hiddenUntilFound` since it requires Panels to remain mounted when closed.");
  }, [n, i]);
  const k = s.useMemo(() => {
    if (p === void 0)
      return V ?? [];
  }, [p, V]), c = _(E), g = s.useRef([]), [o, u] = U({
    controlled: p,
    default: k,
    name: "Accordion",
    state: "value"
  }), M = s.useCallback((d, b) => {
    if (C)
      if (b) {
        const e = o.slice();
        e.push(d), u(e), c(e);
      } else {
        const e = o.filter((w) => w !== d);
        u(e), c(e);
      }
    else {
      const e = o[0] === d ? [] : [d];
      u(e), c(e);
    }
  }, [c, C, u, o]), m = s.useMemo(() => ({
    value: o,
    disabled: t,
    orientation: l
  }), [o, t, l]), P = s.useMemo(() => ({
    accordionItemRefs: g,
    direction: f,
    disabled: t,
    handleValueChange: M,
    hiddenUntilFound: n ?? !1,
    keepMounted: i ?? !1,
    loop: A,
    orientation: l,
    state: m,
    value: o
  }), [f, t, M, n, i, A, l, m, o]), j = T("div", r, {
    state: m,
    ref: a,
    props: [{
      dir: f,
      role: "region"
    }, N],
    customStyleHookMapping: z
  });
  return /* @__PURE__ */ h.jsx(q.Provider, {
    value: P,
    children: /* @__PURE__ */ h.jsx(L, {
      elementsRef: g,
      children: j
    })
  });
});
process.env.NODE_ENV !== "production" && (y.displayName = "AccordionRoot");
const B = O({
  base: [
    "Accordion__Root",
    "flex",
    "w-full",
    "flex-col",
    "justify-center",
    "text-gray-900"
  ],
  variants: {}
}), te = (v) => {
  const { children: r, className: a, openMultiple: x = !1, ...R } = v;
  return F.forEach(r, (t) => {
    var n;
    !I(t) && ((n = t.type) == null ? void 0 : n.displayName) !== "AccordionItem" && console.error(
      "Accordion only accepts AccordionItem components as children."
    );
  }), /* @__PURE__ */ h.jsx(
    y,
    {
      className: B({
        className: typeof a == "string" ? a : ""
      }),
      openMultiple: x,
      ...R,
      children: r
    }
  );
};
export {
  te as default
};
